import { CFG } from './config';
import type { DayData, StravaActivity } from './types';

async function safeFetch<T>(url: string, timeoutMs = 5000): Promise<T> {
  const res = await fetch(url, { signal: AbortSignal.timeout(timeoutMs) });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json() as T;
}

export async function fetchWeek(endDate: string): Promise<DayData[]> {
  return safeFetch<DayData[]>(`${CFG.api}/api/calories/week?end=${endDate}`);
}

export async function fetchStravaWeek(endDate: string): Promise<StravaActivity[] | { error: string; authUrl?: string }> {
  return safeFetch(`${CFG.strava}/api/strava/week?end=${endDate}`);
}
